import(/* webpackMode: "eager" */ "/home/runner/work/personal-website/personal-website/app/(tools)/tools/curl-to-fetch/page.tsx");
